import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-speedtest', 'IconBrandSpeedtest', [
  ['path', { d: 'M5.636 19.364a9 9 0 1 1 12.728 0', key: 'svg-0' }],
  ['path', { d: 'M16 9l-4 4', key: 'svg-1' }],
]);
